import api from './api';

export const aboutApi = {
  // 컨텐츠 조회
  getContent: async (type = 'about', locale = 'ko', config = {}) => {
    try {
      const response = await api.getPublic(
        `/about?type=${encodeURIComponent(type)}&locale=${encodeURIComponent(locale)}`,
        { ...config, suppressGlobalError: true },
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { data: { content: '' } };
      }
      throw error;
    }
  },

  // 컨텐츠 수정
  updateContent: async (content, type = 'about', locale = 'ko', config = {}) => {
    const response = await api.postAuth(
      `/about?type=${type}&locale=${locale}`,
      {
        content: content,
      },
      config,
    );
    return response.data;
  },
};
